<template>
	<!-- 修改密码 -->
	<div class="aboutYjBox">
		<!-- 头部 -->
		<van-sticky>
			<div class="headerBox">
				<div class="headerQuery">
					<div class="arrImg" @click="back">
						<img src="../../assets/img/leftarr_tit.png" alt="">
					</div>
					<p class="header_titile">定制收藏类别</p>
				</div>
			</div>
		</van-sticky>
		<div class="madeCateBox">
			<div class="madeListTit">
				<div>排序</div>
				<div>类别名称</div>
				<div>操作</div>
			</div>
			<div class="madeListTit" v-for="(item,index) in madeCateList">
				<div><input type="number" :placeholder="item.sort" v-model="editSort"></div>
				<div><input type="text" :placeholder="item.name" v-model="editName"></div>
				<div>
					<button class="active" @click="editBtnFn(item)">保存</button>
					<button @click="deleBtnFn(item)">删除</button>
				</div>
			</div>
		</div>
		<div class="newBtnCategry" @click="madeCategrayFn">
			<button>新增类别</button>
		</div>
		<div class="madeCategray" v-show="madeCategrayShow == true">
			<div @click="closeMaskFn" class="mask"></div>
			<div class="formBox">
				<div class="madeName">
					<span>类别名称</span>
					<input type="text" v-model="cateName" placeholder="请输入类别名称">
				</div>
				<div class="madeSolt">
					<span>排序</span>
					<input type="number" v-model="cateSolt" placeholder="0">
				</div>
				<div class="btnCate" @click.stop="addCateFn">
					<button>增加</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {Toast} from 'vant';
	export default {
		data() {
			return {
				mobile: '',
				codeTxt:'',
				madeCategrayShow: false,
				cateName: '',
				cateSolt: 0,
				editSort: '',
				editName: '',
				madeCateList:[],
			}
		},
		created() {
			this.initFn();
		},
		methods: {
			back() {
				this.$router.push('/bookshelf')
			},
			closeMaskFn(){
				this.madeCategrayShow = false;
			},
			madeCategrayFn(){
				this.madeCategrayShow = true;
			},
			initFn(){
				this.$axios.post(this.$api.collect_type_list).then(res => {
					this.madeCateList = res.data.data;
				})
			},
			addCateFn(){
				if(this.cateName != ''){
					this.$axios.post(this.$api.add_collect_type,{
						name: this.cateName,
						sort: this.cateSolt,
						type_id: 0,
					}).then(res => {
						Toast(res.data.msg);
						this.madeCategrayShow = false;
						this.initFn();
					})
				}else{
					Toast('请输入类别名称');
				}
				
			},
			editBtnFn(item){
				this.$axios.post(this.$api.add_collect_type,{
					sort: this.editSort !='' ? this.editSort : item.sort,
					name: this.editName !='' ? this.editName : item.name,
					type_id: item.id,
				}).then(res => {
					Toast(res.data.msg);
					this.initFn();
				})
			},
			deleBtnFn(item){
				this.$axios.post(this.$api.del_collect_type,{
					type_id: item.id,
				}).then(res => {
					Toast(res.data.msg);
					this.initFn();
				})
			}
		}
	}
</script>

<style lang="less" scoped>
	.aboutYjBox{
		background-color: #fff;
		height: 100vh;
		width: 100vw;
		overflow: hidden;
		overflow-y: scroll;
		// 头部
		.headerBox {
			height: 160px;
			background-color: #ff4081;
			display: flex;
			background: url(../../assets/img/myicon/indexBgc.png) no-repeat 0% 88%;
			background-size: 100%;
			border-bottom: 1px solid #f0f0f0;/*no*/
			.headerQuery {
				margin-top: 80px;
				padding: 0 16px;
				position: relative;
				display: flex;
				width: 100%;
				height: 80px;
				line-height: 80px;
				color: #000;
		
				.arrImg {
					img {
						width: 40px;
						position: absolute;
						top: 50%;
						transform: translateY(-50%);
						left: 0px;
					}
				}
		
				.header_titile {
					flex: 1;
					text-align: center;
					font-size: 34px;
					/*px*/
				}
			}
		
		}
	
		.madeCategray {
			background-color: rgba(0,0,0,.3);
			width: calc(100vw - 40px);
			padding: 20px;
			line-height: 80px;
			font-size: 32px;
			position: fixed;
			top: 0;
			left: 0;
			height: 100vh;
			overflow: hidden;
			background: url(../../assets/img/pltost.png) no-repeat 0px calc(100vh - 440px) rgba(0,0,0,.3);
			background-size: 100%;
			.mask{
				height: calc(100vh - 480px);
			}
			.formBox{
				width: calc(100vw - 40px);
				padding: 20px;
				position: absolute;
				bottom: 40px;
				left: 0;
				background-color: #fff;
			}
			.madeName{
				display: flex;
				span{
					padding-right: 10px;
				}
				input{
					flex:1;
					border-bottom: 1px solid #e5e5e5;/*no*/
					padding-left: 20px;
					color: #000;
				}
				input::placeholder{
					color: #7F7F7F;
				}
			}
			.madeSolt{
				margin-top: 20px;
				display: flex;
				span{
					padding-right: 75px;
				}
				input{
					flex:1;
					border-bottom: 1px solid #e5e5e5;/*no*/
					padding-left: 20px;
					color: #000;
				}
				input::placeholder{
					color: #7F7F7F;
				}
			}
			.btnCate{
				margin-top: 30px;
				text-align: center;
				button{
					border: 0;
					background-color: #ff4081;
					color: #fff;
					border-radius: 10px;
					width: calc(100vw - 40px);
				}
			}
		}
	
		.madeCateBox{
			height: calc(100vh - 260px);
			overflow-y: scroll;
			.madeListTit{
				width: calc(100vw - 20px);
				line-height: 60px;/*px*/
				
				font-size: 30px;
				margin: 0 auto;
				div{
					width: calc((100vw - 140px) / 2);
					text-align: center;
					display: inline-block;
					overflow: hidden;
					line-height: 60px;/*px*/
					input{
						width: 100%;
						text-align: center;
						border: 0;
						outline: none;
					}
					input::placeholder{
						color: #000;
					}
				}
				div:first-of-type{
					width: 100px;
					margin-right: 20px;
					border-bottom: 1px solid #f0f0f0;/*no*/
					line-height: 60px;/*px*/
					input{
						width: 100px;
						text-align: center;
						border: 0;
						outline: none;
					}
					input::placeholder{
						color: #000;
					}
				}
				div:nth-child(2){
					border-bottom: 1px solid #f0f0f0;/*no*/
					line-height: 60px;/*px*/
				}
				div:nth-child(3){
					border-bottom: 1px solid #f0f0f0;/*no*/
					line-height: 60px;/*px*/
					button{
						width: 100px;
						height: 40px;/*px*/
						line-height: 40px;/*px*/
						border: 0;
						margin-right: 10px;
						border-radius: 8px;
					}
					button:last-child{
						margin: 0;
					}
					.active{
						color: #fff;
						background-color: #ff4081;
					}
				}
			}
		}
		.newBtnCategry{
			text-align: center;
			button{
				width: calc(100vw - 40px);
				background-color: #ff4081;
				color: #fff;
				border: 0;
				line-height: 80px;
				border-radius: 10px;
				font-size: 30px;/*px*/
			}
		}
	}

</style>
